import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { NotFoundPage as DesignSystemNotFoundPage } from '@hofsync/design-system';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <DesignSystemNotFoundPage
      title={t('notFound.title')}
      description={t('notFound.description')}
      buttonText={t('notFound.button')}
      onButtonClick={handleGoHome}
    />
  );
};

export default NotFoundPage;
